"use client";

import React from "react";
import Image from "next/image";

type LogoVariant =
  | "square-black"
  | "square-white"
  | "square"
  | "colored"
  | "white";

interface LogoProps {
  variant?: LogoVariant;
  width?: number | string;
  height?: number | string;
  alt?: string;
  style?: React.CSSProperties;
  className?: string;
  priority?: boolean;
  href?: string;
}

const Logo: React.FC<LogoProps> = ({
  variant = "colored",
  width,
  height,
  alt = "NestShipper Logo",
  style,
  className = "",
  priority = false,
  href = "/",
}) => {
  const logoMap: Record<LogoVariant, string> = {
    "square-black": "/logos/logo-square-black.png",
    "square-white": "/logos/logo-square-white.png",
    square: "/logos/logo-square.png",
    colored: "/logos/logo-colored.png",
    white: "/logos/logo-white.png",
  };

  const src = logoMap[variant];

  return (
    <Image
      src={src}
      alt={alt}
      width={typeof width === "number" ? width : undefined}
      height={typeof height === "number" ? height : undefined}
      style={{
        objectFit: "contain",
        flexShrink: 0,
        ...style,
        cursor: href ? "pointer" : "default",
      }}
      priority={priority}
      className={className}
      onClick={() => {
        if (href) {
          window.location.href = href;
        }
      }}
    />
  );
};

export default Logo;
